const a = 100000000;

export function priceAtSupply(supply: number) {
  return (supply / a) ** 2;
}

// Bonding curve price at specified supply
export function supplyAtPrice(price: number) {
  //#NOM Sold = sqrt(ETH/NOM) * a
  return Math.sqrt(price) * a;
}

// NOM supply range to ETH
export function NOMsupplyETH(supplyTop: number, supplyBot: number) {
  // Integrate over curve to get amount of ETH needed to buy amount of NOM
  // ETH = a/3((supplyNOM_Top/a)^3 - (supplyNOM_Bot/a)^3)
  return (a / 3) * ((supplyTop / a) ** 3 - (supplyBot / a) ** 3);
}
